import { BedroomIcon, BathroomIcon, VillaIcon } from './PropertyIcons';

interface PropertyCardProps {
  image: string;
  title: string;
  description: string;
  bedrooms: number;
  bathrooms: number;
  propertyType: string;
  price: string;
}

export default function PropertyCard({
  image,
  title,
  description,
  bedrooms,
  bathrooms,
  propertyType,
  price,
}: PropertyCardProps) {
  return (
    <div className="flex flex-col gap-4 p-4 md:p-5 border border-gray-200 bg-[var(--color-tertiary)] flex-1">
      <img 
        src={image} 
        alt={title} 
        className="w-full h-[160px] md:h-[200px] object-cover"
      />
      
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <h3 className="text-base md:text-lg font-semibold leading-[150%] text-[var(--color-secondary)]">
            {title}
          </h3>
          <p className="text-xs md:text-sm font-normal leading-[150%]">
            <span className="text-[var(--color-secondary)]/80">{description}... </span>
            <span className="text-[var(--color-secondary)] underline cursor-pointer hover:text-[var(--color-secondary)]/80 transition-colors">Read More</span>
          </p>
        </div>
        
        <div className="flex flex-wrap gap-1.5">
          <div className="flex items-center gap-0.5 px-2 py-1 border border-gray-200 bg-gray-50 whitespace-nowrap">
            <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
              <BedroomIcon />
            </div>
            <span className="text-xs font-medium text-[var(--color-secondary)]">
              {bedrooms}-Bedroom
            </span>
          </div>
          
          <div className="flex items-center gap-0.5 px-2 py-1 border border-gray-200 bg-gray-50 whitespace-nowrap">
            <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
              <BathroomIcon />
            </div>
            <span className="text-xs font-medium text-[var(--color-secondary)]">
              {bathrooms}-Bathroom
            </span>
          </div>
          
          <div className="flex items-center gap-0.5 px-2 py-1 border border-gray-200 bg-gray-50 whitespace-nowrap">
            <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
              <VillaIcon />
            </div>
            <span className="text-xs font-medium text-[var(--color-secondary)]">
              {propertyType}
            </span>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row items-start sm:items-end gap-3 md:gap-4">
          <div className="flex flex-col gap-0.5">
            <span className="text-xs md:text-sm font-normal leading-[150%] text-[var(--color-secondary)]/70">
              Price
            </span>
            <span className="text-base md:text-lg font-semibold leading-[150%] text-[var(--color-secondary)]">
              {price}
            </span>
          </div>
          
          <button className="flex-1 w-full sm:w-auto flex items-center justify-center gap-2 px-3 py-2 bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90 transition-colors whitespace-nowrap">
            <span className="text-xs font-medium text-white">
              View Property Details
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}


